import React from "react";

import { brand } from "../../../config/brand";

import "./SchoolFooterCopyright.css";

const currentYear = new Date().getFullYear();

const SchoolFooterCopyright = () => {
  return (
    <div className="school-footer-copyright">
      <span>
        {/* © {currentYear} {brand.lines.join(" ")} */}
        © {currentYear} CKZiU Wyrzysk
      </span>

      <span className="school-footer-copyright-separator">
        •
      </span>

      <span>
        Wszelkie prawa zastrzeżone.
      </span>
    </div>
  );
};

export default SchoolFooterCopyright;